// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a814c94c","453":"2a6e33a7","455":"783912a8"}[chunkId] + ".chunk.js";
};